import React from 'react';
import PropTypes from 'prop-types';

import './writer-badge.css';

const WriterBadge = ({ name = 'Dor Moshe', clickUrl, height = 222, width = 222, small = false }) => {
  if (!name) return null;

  const imgUrl = `/images/writers/${ name.toLowerCase().split(' ').join('_') }${ small && '_small' || '' }.png`;

  const badge = <img src={ imgUrl } height={ height } width={ width } alt={ name } />;

  return (
    <div className='writer-badge-container'>
      {
        clickUrl ? 
          <a href={ clickUrl } target='_blank'>{ badge }</a>
          : badge
      }
    </div>
  );
}

WriterBadge.propTypes = {
  name: PropTypes.string.isRequired,
  clickUrl: PropTypes.string,
};

export default WriterBadge;